// Pure, shared by Capacity and the server's read-only policy preview.
export function classify(demand, seats, max, bufferPct = 10) {
  if (!Number.isFinite(bufferPct)) return "no_data";
  if (demand == null || !Number.isFinite(demand) || demand < 0) return "partial";
  if (seats == null || !Number.isFinite(seats) || seats < 0) return "no_data";
  if (seats === 0) return demand > 0 ? "over" : "no_seats";
  const ratio = demand / seats;
  return ratio < (100 - bufferPct) / 100 ? "comfortable" : ratio <= 1 ? "tight" : "over";
}
export function outlookMonthStatus(month, demand, seats, max, bufferPct) {
  if (month?.excluded) return "excluded";
  if (demand == null) return "partial";
  if (month?.insufficientHistory) return "history";
  if (month?.missingCapacity || month?.missingAttendance) return "no_data";
  return classify(demand, seats, max, bufferPct);
}
